$(function() {
    if ($(".ego-c-findadealer-sc").length) {
        let serviceCenterTableBody = $("#ego-c-findadealer-sc-table tbody");

        $.get(findADealerCSV, function (CSVdata) {
            data = $.csv.toObjects(CSVdata);
            $(data).each(function (i, obj) {
                serviceCenterTableBody.append("<tr>" +
                    "<td>" + obj["partner_type"] + "</td>" +
                    "<td>" + obj["ship_to_name"] + "</td>" +
                    "<td>" + obj["shipping_address"] + "</td>" +
                    "<td>" + obj["shipping_city"] + "</td>" +
                    "<td>" + obj["shipping_state"].toUpperCase() + "</td>" +
                    "<td>" + obj["shipping_zip"] + "</td>" +
                    "<td>" + addPhoneLink(obj["phone"]) + "</td>" +
                    "</tr>");
            });
        });

        $("#js-service-center").selectmenu({
            change: function () {
                var input, filter, table, tr, td, i;
                input = document.getElementById("js-service-center");
                filter = input.value.toUpperCase();
                table = document.getElementById("ego-c-findadealer-sc-table");
                tr = table.getElementsByTagName("tr");

                for (i = 0; i < tr.length; i++) {
                    td = tr[i].getElementsByTagName("td")[4];
                    if (td) {
                        if (td.innerHTML.replace('&amp;', '&').toUpperCase() == filter || filter == "ALL LOCATIONS") {
                            tr[i].style.display = "";
                        } else {
                            tr[i].style.display = "none";
                        }
                    }
                }
            }
        });

        let mapToggleButtons = $(".ego-c-btn-map-toggle");

        mapToggleButtons.click(function (e) {
            e.preventDefault();
            let _this = $(this);
            mapToggleButtons.removeClass("active");
            _this.addClass("active");

            let buyNowWidget = $(".ego-c-findadealer-map__col .cswidget");
            let parentElement = buyNowWidget.parent();

            buyNowWidget.remove();

            let loadingSpinner = document.createElement("div");
            loadingSpinner.className = "ego-c-loading";

            let widgetDiv = document.createElement("div");
            widgetDiv.className = "cswidget cswidget-offline";
            widgetDiv.dataset.assetId = _this.data("asset-id");
            widgetDiv.appendChild(loadingSpinner);
            parentElement.append(widgetDiv);

            reInitializeCS();
        });
    }

    function addPhoneLink(phone) {
        if (!phone) return "";
        const digits = phone.replace(/\D/g, ""); // keep only numbers
        if (digits.length === 10) {
            const formatted = digits.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3");
            return `<a href="tel:${digits}">${formatted}</a>`;
        }
        return ""; // ignore if not 10 digits
    }
});